// Central Mermaid configuration
// NOTE: Extremely large limits like those provided can impact performance.
// Adjust carefully to avoid browser memory exhaustion.

const mermaidConfig = {
  startOnLoad: false,
  theme: 'default',
  // Note: Not specifying layout algorithm - uses default dagre renderer
  // which handles subgraph spacing better than elk
  // Custom performance/security related overrides
  // Guard rails: large enough for very big tenants, small enough that a
  // runaway diagram fails with a Mermaid error instead of hanging the tab.
  maxTextSize: 20000000,
  maxEdges: 100000,
  securityLevel: 'loose',
  fontFamily: 'Arial, sans-serif',
  // Flowchart settings for better text display
  flowchart: {
    htmlLabels: true,
    useMaxWidth: false,  // Don't constrain width - let nodes expand to fit text
    nodeSpacing: 50,
    rankSpacing: 100,    // Increased for better vertical spacing
    curve: 'basis',
    padding: 20,         // Increased padding inside nodes
    diagramPadding: 15,
    wrap: true,          // Enable text wrapping
    subGraphTitleMargin: {
      top: 15,
      bottom: 15
    }
  },
  // ELK-specific configuration
  elk: {
    nodePlacementStrategy: 'SIMPLE',
    'elk.spacing.nodeNode': 50,
    'elk.spacing.edgeNode': 50,
    'elk.layered.spacing.nodeNodeBetweenLayers': 100,
    'elk.algorithm': 'layered',
    'elk.direction': 'DOWN'
  },
  // Themeables to ensure text fits in nodes
  themeVariables: {
    fontSize: '14px',
    nodePadding: 20,     // Increased padding
    primaryTextColor: '#fff',
    primaryBorderColor: '#666',
    lineColor: '#666',
    secondBkgColor: '#222',
    tertiaryTextColor: '#fff'
  }
};

export default mermaidConfig;
